/* 
This is the formatPhoneNumber function that is used to format the phone number.
Example: +14085837285 -> +1 (408) 583-7285
*/
const formatPhoneNumber = (phone: string) => {
  return phone.replace(/(\+\d{1,3})?(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4').trim()
}

export { formatPhoneNumber }
